const binding = { modules: {}, dataActions: {} };

    (binding.modules['social-share'] = {
        c: () => require('@msdyn365-commerce-modules/social-share/dist/lib/modules/social-share/social-share'),
        $type: 'moduleDefinition',
        da: [],
        
        iNM: true,
        ns: '@msdyn365-commerce-modules',
        n: 'social-share',
        p: 'social-share',
        
        pdp: '',
        
        
        md: 'node_modules/@msdyn365-commerce-modules/social-share/dist/lib/modules/social-share'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|themes|moekwrsitetheme|views|social-share'] = {
                c: () => require('partner/themes/moekwrsitetheme/views/social-share.view.tsx'),
                cn: '__local__-__local__-social-share'
            };
viewDictionary['__local__|__local__|themes|moenzcsitetheme|views|social-share'] = {
                c: () => require('partner/themes/moenzcsitetheme/views/social-share.view.tsx'),
                cn: '__local__-__local__-social-share'
            };
viewDictionary['__local__|__local__|themes|moetwksitetheme|views|social-share'] = {
                c: () => require('partner/themes/moetwksitetheme/views/social-share.view.tsx'),
                cn: '__local__-__local__-social-share'
            };
viewDictionary['@msdyn365-commerce-modules|social-share|modules|social-share|social-share'] = {
                c: () => require('@msdyn365-commerce-modules/social-share/dist/lib/modules/social-share/social-share.view.js'),
                cn: '@msdyn365-commerce-modules-social-share-social-share'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };